import React, { useEffect, useState } from 'react'
import {
    IconButton,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Spinner,
} from "@material-tailwind/react";
import { BlobProvider, PDFDownloadLink } from '@react-pdf/renderer';
import { useShared } from '../../hooks/useShared';
import AIcon from '../../components/partials/AIcon';
import InvoicePdf from './InvoicePdf';
import Resizer from "react-image-file-resizer";

export default function AMenu({ v }) {
    const { com, http, consts,auth, toWords } = useShared();
    const [generatePDF, setGeneratePDF] = useState(false)

    const setOpenData = (flag) => {
        console.log("object", flag);
        // setGeneratePDF(pre => !pre)
        v.handleMenu(v.model, flag)
    }

   
;

    return (
        <Menu
            animate={{
                mount: { y: 0 },
                unmount: { y: 25 },
            }}
        >
            <MenuHandler>
                <IconButton disabled={auth.hasRole([3])} variant="text" className={`h-5 $`}>
                    <AIcon name="ellipsis-horizontal-outline" className="text-main-color text-lg" />
                </IconButton>
            </MenuHandler>

            <MenuList className="min-w-[100px] bg-main-color p-1">


                <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('pdf')}>

                    <AIcon name={`logo-foursquare`} className="mr-2" /> PDF ايجاد 
                   {/*  <BlobProvider document={<InvoicePdf v={{ model: v.model, com, consts, http, toWords }} />}
                        fileName={'Invoice.pdf'}>
                        {({ blob, url, loading, error }) => {
                            return (<> {loading ? <div className='flex '> <Spinner className="h-4 w-4 mr-1" /> PDF ...</div> : !loading && url ? <a href={url} target="_blank" rel="noreferrer"> PDF ايجاد   </a> : null} </>)

                        }}
                    </BlobProvider>
 */}

                </MenuItem>
                <hr className="my-1 text-cyan-900" />
                <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('upload file')}>
                    <AIcon name={`cloud-upload-outline`} className="mr-2" /> آپلود فایل
                </MenuItem>

                <hr className="my-1 text-cyan-900" />
                {(auth?.hasRole([1,2,18]) ||((v?.model?.status === 0||v?.model?.status === 1) && (auth?.isCreator(v?.model?.creator_id)||auth?.isCreator(v?.model?.company?.owner?.value)))) && <><MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('edit')}>
                    <AIcon name={`create-outline`} className="mr-2" /> ویرایش
                </MenuItem>
                    <hr className="my-1 text-cyan-900" /></>}

                {(v.model?.status === 1&& auth.hasRole([1, 2, 18]) )&& <>
                    <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('approve')}>
                        <AIcon name={`checkmark-circle-outline`} className="mr-2" /> تایید
                    </MenuItem>
                    <hr className="my-1 text-cyan-900" /></>}
                {(auth.hasRole([1,2]) || (v?.model?.status === 0 && auth.isCreator(v?.model?.creator_id))) && <> <MenuItem className={`flex  items-center p-1 text-white `} onClick={() => setOpenData('delete')}>
                    <AIcon name={`trash-outline`} className="mr-2" /> حذف
                </MenuItem></>}


            </MenuList>
        </Menu>
    )
}
